/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLeavePeriodData
 */
export interface UpdateLeavePeriodData {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLeavePeriodData
     */
    confirmed?: boolean;
}

/**
 * Check if a given object implements the UpdateLeavePeriodData interface.
 */
export function instanceOfUpdateLeavePeriodData(value: object): value is UpdateLeavePeriodData {
    return true;
}

export function UpdateLeavePeriodDataFromJSON(json: any): UpdateLeavePeriodData {
    return UpdateLeavePeriodDataFromJSONTyped(json, false);
}

export function UpdateLeavePeriodDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeavePeriodData {
    if (json == null) {
        return json;
    }
    return {
        
        'confirmed': json['confirmed'] == null ? undefined : json['confirmed'],
    };
}

  export function UpdateLeavePeriodDataToJSON(json: any): UpdateLeavePeriodData {
      return UpdateLeavePeriodDataToJSONTyped(json, false);
  }

  export function UpdateLeavePeriodDataToJSONTyped(value?: UpdateLeavePeriodData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'confirmed': value['confirmed'],
    };
}

